import { getStorageURL } from '@/utils'

import render from './render'

export default {
  name: 'ButtonsDownload',

  props: {
    value: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  methods: {
    download() {
      window.location.href = getStorageURL([ this.value.documentId ])
    }
  },

  render
}
